import type {FC} from 'react';
import {Stack, Typography} from '@wellstone-solutions/web';

interface CountdownHelperTextProps {
  countdown: number;
  helperText?: string;
}
export const CountdownHelperText: FC<CountdownHelperTextProps> = ({
  countdown,
  helperText,
}) => {
  return (
    <Stack
      direction="row"
      justifyContent={helperText ? 'space-between' : 'flex-end'}>
      {Boolean(helperText && helperText.length > 0) && (
        <Typography fontSize={12}>{helperText}</Typography>
      )}
      <Typography
        fontSize={12}
        color={countdown > -1 ? 'text.secondary' : 'error.main'}>
        {countdown > -1
          ? `${countdown} characters remaining`
          : 'Character count exceeded'}
      </Typography>
    </Stack>
  );
};
